import { render, staticRenderFns } from "./ConocimientosExperiencia.vue?vue&type=template&id=a2dd03f8&scoped=true"
import script from "./ConocimientosExperiencia.vue?vue&type=script&lang=js"
export * from "./ConocimientosExperiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dd03f8",
  null
  
)

export default component.exports